import { createStore, createEvent } from "effector"
import { IConfirmModalProps } from "components/ConfirmModal/ConfirmModal"

const show = createEvent<IConfirmModalProps>()
const hide = createEvent<IConfirmModalProps>()
const clear = createEvent()

const list = createStore<IConfirmModalProps[]>([])

list.on(show,
    (state: IConfirmModalProps[], props: IConfirmModalProps) => [...state, props]
)

list.on(hide,
    (state: IConfirmModalProps[], props: IConfirmModalProps) => state.filter(a => a !== props)
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list
}
